import { ChartConfig } from '@/core/design-system/Chart';
import _ from 'lodash';

const generatePieChartConfig = (data: { name: string; count: number }[], colorMap: Record<string, string>) => {
  const config: ChartConfig = {
    count: { label: 'Visitors' },
  };

  data.forEach(({ name }) => {
    config[name] = {
      label: name,
      color: colorMap[name] || 'var(--pie-chart-1)',
    };
  });

  return config;
};

export default generatePieChartConfig;
